<template>
    <i @click="close" class="fas fa-times"></i>
    <div class="row"><h3 class="mb-4 col p-0">Факт исполнения</h3></div>
    <div class="row mb-4">
        <div class="col p-0 fw-bold">Дата</div>
        <div class="col p-0 fw-bold">Оцените качество оказания услуги</div>
    </div>
    <template v-if="items">

        <div class="row border-bottom mt-3" v-for="item in items" v-bind:key="item.id">
            <div class="col d-flex p-0">
                <p class="p-0 control-label">{{ $moment.format(item.dateVisit, "DD.MM.YYYY") }}</p>
                <span class="mx-3"><i style="color: #34C759" class="fas fa-check-circle"></i></span>
            </div>
            <div class="col p-0">
                <star-rating :rating="item.mark" :editable="item.mark == null" :parent-id="item.id" @update="updateRating" />
            </div>
        </div>

    </template>

</template>

<script>

import API from '../api/imar'
import Constants from '@/common/constants'
import StarRating from "./StarRating";
export default {
    name: "VisitModal",
    components: {StarRating},
    props: {
        items: Array
    },
    methods: {
        close() {
            this.$emit('close');
        },
        updateRating(id,mark) {
            var alertOptions = {
                    title: 'Подтверждение',
                    text: 'Вы действительно хотите оценить это занятие на ' + mark + '?',
                    confirmButtonText: 'Да',
                    cancelButtonText: 'Нет',
                    showCancelButton: true,
                    icon: 'warning',
                };
                Constants.alert.fire(alertOptions).then((res) => {
                    if (res.isConfirmed) {
                        var data = {
                            id: id,
                            mark: mark
                        };
                        API.saveVisitMark(data).then(response => {
                        if(response.data.success)
                            this.items.find(o => o.id == id).mark = mark;
                        else {
                            Constants.alert.fire('Ошибка', response.data.message ? response.data.message : 'Произошла ошибка при сохранении оценки', 'error');
                        }
                    });              
                    }
                });

        }
    }
}

</script>
<style scoped lang="scss">
.modal-body{
    position: relative;
}

.fa-times {
    position: absolute;
    content: "";
    top: 0;
    right: 0;
}
</style>
